import { IProduct } from '../../types/IProduct'

export const getProduct = (products: IProduct[], id: string): IProduct | undefined => {
  return [...products].find((product) => product.id === id)
}
